import React from 'react';

function Login() {
  return (
    <main
      style={{
        minHeight: '70vh',
        display: 'grid',
        placeItems: 'center',
        padding: '120px 24px 64px'
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800 }}>Přihlášení</h1>
        <p style={{ margin: '12px 0 0', color: '#666' }}>
          Použijte panel vlevo pro přihlášení do Editry.
        </p>
      </div>
    </main>
  );
}

export default Login;
